import React, { useEffect, useState } from "react";
import { Form, Link, useNavigate } from "react-router-dom";
import { SignInImages, people } from "../config/imagesLink";
import AuthSplitLayout from "./Auth/AuthSplitLayout";
import AuthField from "./Auth/AuthField";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined"; 
import axios, { PublicKey } from "../API/axios";
import { completeLoginNotificationFetch } from "../Services/apiService";
import fetch_axios from "axios";
import { useFormik } from "formik";
import { loginValidations } from "./Validations";
import { useGoogleLogin } from "@react-oauth/google";
import SuccessToast from "./SuccessToast";
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import { signInWithPopup, OAuthProvider } from "firebase/auth";
import { auth } from "../config/firebase";
import i18n from "../i18n";
import { setStoredLangCode } from "../utils/language";

 const SignIn = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState("false");
  const language = localStorage.getItem("Lang");


  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [sessionId, setSessionId] = useState(""); 
  const [User_Name, setuserName] = useState("");
  const [confimAcc, setconfirmAcc] = useState("");
  const [Response_Message, setmessage] = useState("");
  const [userID, setuserID] = useState("");
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n?.language || localStorage.getItem("Lang") || "en");
  const handleChangeOtp = (otp) => setOtp(otp);
  const getApiMessage = (error, fallback = "Login failed") =>
    error?.response?.data?.message || error?.message || fallback;
  const getResponseMessage = (res, fallback = "Login failed") =>
    res?.data?.message || fallback;
  const isLoginSuccessResponse = (res) =>
    res?.data?.status === "Success" &&
    res?.data?.responseData &&
    res?.data?.responseData?.profile;
  const resetToasts = () => {
    setShowToast(false);
    setToastMessage("");
    setShowWarningToast(false);
    setWarningToastMessage("");
    setShowErrorToast(false);
    setErrorToastMessage("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [loading, setLoading] = useState(false);
  const [loadOTP, setLoadOTP] = useState(false);
  const initialValues = {
    email: localStorage.getItem("user-email") || "",
    password: "",
  };

  const { values, errors, handleBlur, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: loginValidations,
      onSubmit: async () => {
        setLoading(true);
        resetToasts();
        const RegisterData = {
          deviceType: "Web",
          email: values.email,
          password: values.password,
          langKey: language === "en" ? "" : language,
        };
        try {
          const res = await axios.post("OAuth/LoginWithEmail", RegisterData, {
            headers: {
              PublicKey,
            },
          }); 
          if (!isLoginSuccessResponse(res)) {
            setErrorToastMessage(getResponseMessage(res));
            setShowErrorToast(true);
            return;
          }
          const response = res.data.responseData.profile;
          const algoData = res.data.responseData.algoData;
          const userRole = res.data.responseData.userRoles;
          setToastMessage(res.data.message);
          setShowToast(true);
          // localStorage.setItem("user-Id", response.id); 
          setStoredLangCode(language === null ? "en" : language);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          if (response.refreshToken) {
            localStorage.setItem("refreshToken", response.refreshToken);
          }
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);
          localStorage.setItem("CheckNotifyId", response.id);

          localStorage.setItem("engagedUsersMostEngagedPostIds", algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", algoData.ownedAllPostIds)

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();
          navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
          // setTimeout(() => {
          // }, 500);
        } catch (error) {
          const errorMessage = getApiMessage(error);
          setShowToast(false);
          setToastMessage("");
          setShowWarningToast(false);
          setWarningToastMessage("");
          if (error.response && error.response.status === 403) {
          console.log("loginconfirm", error.response.data.responseData.accountConfirmed);

            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
            setFlag(true);
            setuserName(error.response.data.responseData.userName);
            setconfirmAcc(error.response.data.responseData.accountConfirmed);
            setmessage(errorMessage);
            setSessionId(error.response.data.responseData.sessionID);
            setuserID(error.response.data.responseData.userId);
          } else if (error.response && error.response.status === 404) {
            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
          } else {
            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
            setTimeout(() => {
              if (errorMessage === "Account not confirmed!") {
                navigate("/ConfirmAccount");
              }
            }, 2000);
          }
        } finally {
          setLoading(false);
        }
      },
    });

  const externalLogin = async (responseData) => {
    resetToasts();
    try {
      const res = await axios.post("OAuth/LoginWithGoogle", responseData, {
        headers: {
          PublicKey,
        },
      });
      if (!isLoginSuccessResponse(res)) {
        setErrorToastMessage(getResponseMessage(res));
        setShowErrorToast(true);
        return;
      }
      console.log("login", res.data.responseData);
      setStoredLangCode(language === null ? "en" : language);
      const data = res.data.responseData;
      const response = res.data.responseData.profile;
      const userRole = res.data.responseData.userRoles;
      // toast.success("Login successful!");
      setToastMessage(res.data.message);
      setShowToast(true);
      setStoredLangCode(language === null ? "en" : language);
      localStorage.setItem("user-Id", response.id);
      localStorage.setItem("userUid", response.userUid);
      localStorage.setItem("user-email", response.email);
      localStorage.setItem("user-nameTag", response.nameTag);
      localStorage.setItem("user-profilPic", response.profilPic);
      localStorage.setItem("user-referCode", response.referCode);
      localStorage.setItem("sessionId", response.sessionId);
      localStorage.setItem("token", response.token);
      if (response.refreshToken) {
        localStorage.setItem("refreshToken", response.refreshToken);
      }
      localStorage.setItem("loginType", response.loginType);
      localStorage.setItem("profilPic", response.profilPic);
      localStorage.setItem("firstName", response.firstName);
      localStorage.setItem("lastName", response.lastName);
      localStorage.setItem("userRole", userRole);
          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)


      localStorage.removeItem("guestMode");
      await completeLoginNotificationFetch();
      navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
      // localStorage.setItem("guestMode", "false");
    } catch (error) {
      const errorMessage = getApiMessage(error);
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (error.response && error.response.status === 403) {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
        setFlag(true);
        setconfirmAcc(error.response.data.responseData.accountConfirmed);
        setuserName(error.response.data.responseData.userName);
        setSessionId(error.response.data.responseData.sessionID);
        setuserID(error.response.data.responseData.userId);
      } else if (error.response && error.response.status === 404) {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
        setTimeout(() => {
          if (errorMessage === "Account not confirmed!") {
            navigate("/ConfirmAccount");
          }
        }, 2000);
      }
    }
  };
  const otpCheck = async (e) => {
setLoadOTP(true);
    e.preventDefault();
    resetToasts();
    try {
      await axios
        .post(
          `OAuth/LoginByOTPFor2FA?OTP=${otp}&SessionID=${sessionId}&UserID=${userID}&DeviceType=Web&LangKey=${language}`, 
        )
        .then(async (res) => {
          console.log("res", res);
          setToastMessage(res.data.message);
          setLoadOTP(false);
          setShowToast(true);
          setFlag(false);

          const response = res.data.responseData.profile;
          const userRole = res.data.responseData.userRoles;
          setToastMessage(res.data.message);
          setShowToast(true);

          localStorage.setItem("user-Id", response.id);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          if (response.refreshToken) {
            localStorage.setItem("refreshToken", response.refreshToken);
          }
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();
          setTimeout(() => {
            navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
          }, 1000);
          // setTimeout(() => {
          //   navigate("/SignIn");
          // }, 2000);


          // if (res.data.length === 0) {

          // } else {
          //   toast.error("Wrong OTP");
          // }
        });
    } catch (error) {
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
          setLoadOTP(false);

      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
          setLoadOTP(false);

      }
    }
  };

  const ConfirmotpCheck = async (e) => {
    e.preventDefault();
    resetToasts();
    try { 
      await axios
        .post(
          `OAuth/ConfirmAccountByOTP?OTP=${otp}&SessionID=${sessionId}&UserID=${userID}&DeviceType=Web`,
          {},
          { headers: { PublicKey } }
        )

        .then(async (res) => {
          console.log("res", res);
          setToastMessage(res.data.message);
          setShowToast(true);
          setFlag(false);

          const data = res.data.responseData;
          const response = res.data.responseData.profile;
          const userRole = res.data.responseData.userRoles;
          setStoredLangCode(language === null ? "en" : language);

          localStorage.setItem("user-Id", response.id);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          if (response.refreshToken) {
            localStorage.setItem("refreshToken", response.refreshToken);
          }
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);

          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();

          setTimeout(() => {
            navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
          }, 2000);
          // if (res.data.length === 0) {

          // } else {
          //   toast.error("Wrong OTP");
          // }
        });
    } catch (error) {
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const googleSignin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const resp = await fetch_axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const responseData = {
          deviceType: "Web",
          email: resp.data.email,
          externalLoginId: resp.data.sub,
          loginType: "Google",
          firstName: resp.data.given_name,
          lastName: resp.data.family_name,
        };
        externalLogin(responseData);
      } catch (error) {
        console.log(error);
      }
    },
  });

  const [guestMode, setGuestMode] = useState(false);
  const activateGuestMode = () => {
    setGuestMode(true);
    navigate("/NewsFeed");
    localStorage.setItem("guestMode", "true");
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [originalemail, setOriginalEmail] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [externalEmail, setExernalEmail] = useState("");

  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handleOtpModalClose = () => {
    setFlag(false);
    setOtp("");
  };
 
  const _loginWithApple = async (accessToken) => {
    resetToasts();
    try {
      const responseData = {
        deviceType: "Web",
        appleAccessToken: accessToken,
        loginType: "Apple",
        langKey: language === "en" ? "" : language,

      };
      const res = await axios.post("OAuth/LoginWithApple", responseData, {
        headers: {
          PublicKey,
        },
      });
      if (!isLoginSuccessResponse(res)) {
        setErrorToastMessage(getResponseMessage(res));
        setShowErrorToast(true);
        return;
      }

      console.log("login", res.data.responseData);
        setStoredLangCode(language === null ? "en" : language);

      const data = res.data.responseData;
      const response = res.data.responseData.profile;
      const userRole = res.data.responseData.userRoles;
      setToastMessage(res.data.message);
      setShowToast(true);
      setStoredLangCode(language === null ? "en" : language);
      localStorage.setItem("user-Id", response.id);
      localStorage.setItem("userUid", response.userUid);
      localStorage.setItem("user-email", response.email);
      localStorage.setItem("user-nameTag", response.nameTag);
      localStorage.setItem("user-profilPic", response.profilPic);
      localStorage.setItem("user-referCode", response.referCode);
      localStorage.setItem("sessionId", response.sessionId);
      localStorage.setItem("token", response.token);
      if (response.refreshToken) {
        localStorage.setItem("refreshToken", response.refreshToken);
      }
      localStorage.setItem("loginType", response.loginType);
      localStorage.setItem("profilPic", response.profilPic);
      localStorage.setItem("firstName", response.firstName);
      localStorage.setItem("lastName", response.lastName);
      localStorage.setItem("userRole", userRole);

          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)

      localStorage.removeItem("guestMode");
      await completeLoginNotificationFetch();
      navigate("/NewsFeed", { state: { toastMessage: res.data.message, toastType: "success" } });
      // localStorage.setItem("guestMode", "false");
    } catch (error) {
      console.error("Error during registration:", error);
      const errorMessage = getApiMessage(error);
      setShowToast(false);
      setToastMessage("");
      setShowWarningToast(false);
      setWarningToastMessage("");
      if (errorMessage === 'User account already exists with associated email address, but not confirmed yet. Please confirm your account and login') {
        setFlag(true)
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
        setconfirmAcc(error.response.data.responseData.accountConfirmed);
        setuserName(error.response.data.responseData.userName);
        setSessionId(error.response.data.responseData.sessionID); 
        setuserID(error.response.data.responseData.userId);

      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };
  const signInWithApple = async () => {
    const provider = new OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log(user.accessToken);
      setFirstName(user.displayName?.split(" ")[0]);
      setLastName(user.displayName?.split(" ")[1]);
      setExernalEmail(user.email);
      setAccessToken(user.accessToken);
      setPhotoUrl(user.photoURL);
      _loginWithApple(user.accessToken);
    } catch (error) {
      console.error("Error signing in with Apple:", error);
    }
  };

  const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
  const ConnectionListAllForGuest = async (id) => {
    try {
      await axios
        .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
        .then((resData) => { 
          setConnectionListForGuest(resData.data.responseData);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // console.log('ConnectionListForGuest', ConnectionListForGuest);

  useEffect(() => {
    ConnectionListAllForGuest();
  }, []);

  const LinktoGuest = () => {
    setGuestMode(true);
    localStorage.setItem("guestMode", "true");
  };

  const [minutes, setMinutes] = useState(1)
  const [seconds, setSeconds] = useState(30)

  const Resend2FAOTP = async (e) => {
    if (seconds > 0 || minutes > 0) return;
    setMinutes(1);
    setSeconds(30);
    e.preventDefault();
    try {
      await axios
        .post(
          `OAuth/Resend2FAOTP?UserID=${userID}`
        )
        .then((res) => {
          console.log("res", res);
          setSessionId(res.data.responseData.sessionID);
          setToastMessage(res.data.message);
          setShowToast(true);
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  }; 

  const resendOTP = async (e) => {
      if (seconds > 0 || minutes > 0) return;
      setMinutes(1);
      setSeconds(30);
      e.preventDefault();
      try {
        await axios.post(`OAuth/ResendOTP?UserID=${userID}`).then((res) => {
          console.log("res", res);
          setToastMessage(res.data.message);
          setShowToast(true);
            setSessionId(res.data.responseData.sessionID);

        });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    if (showModal || flag) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [showModal, flag]);

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const changeLanguage = (lang) => {
    const code = setStoredLangCode(lang);
    i18n.changeLanguage(code);
    setCurrentLang(code);
    document.documentElement.lang = code;
    document.documentElement.dir = code === "ar" ? "rtl" : "ltr";
  };

  return (
    <>
      <AuthSplitLayout
        switchPrompt={t("SignIn.New User")}
        switchTo="/SignUp"
        switchLabel={t("SignIn.Create an account")}
        connectionList={ConnectionListForGuest}
        onGuestNavigate={LinktoGuest}
        currentLang={currentLang}
        onChangeLanguage={changeLanguage}
        onProfileImageError={handleProfileImageError}
      >
        <div className="auth-form-heading">
          <h2>{t("SignIn.Welcome Back", { defaultValue: "Welcome Back" })}</h2>
          <p>
            {t("SignIn.Enter your details to continue", {
              defaultValue: "Enter your details below to sign in.",
            })}
          </p>
        </div>

        <Form onSubmit={handleSubmit}>
          <AuthField
            id="email"
            name="email"
            type="text"
            placeholder={t("Manage Companies.Email Id")}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.email}
            touched={touched.email}
            autoComplete="email"
            icon={<MailOutlineOutlinedIcon />}
          />

          <AuthField
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder={t("SignIn.Password")}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password}
            touched={touched.password}
            autoComplete="current-password"
            icon={<LockOutlinedIcon />}
            rightSlot={
              <button
                type="button"
                className="auth-field-toggle"
                onClick={togglePasswordVisibility}
                aria-label={t("Common.TogglePassword")}
              >
                {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
              </button>
            }
          />

          <div className="auth-forgot-row">
            <Link to="/ForgotPassword">{t("SignIn.Forgot Password")}</Link>
          </div>

          <button type="submit" className="auth-submit" disabled={loading}>
            <LoginOutlinedIcon />
            <span>{loading ? t("SignIn.Loading") : t("SignIn.Sign in")}</span>
          </button>
        </Form>

        <div className="auth-or">{t("SignIn.or continue with", { defaultValue: "or continue with" })}</div>
        <div className="auth-social-row">
          <button type="button" className="auth-social-btn" onClick={googleSignin}>
            <img src={SignInImages.google} alt="" />
            <span>{t("SignIn.Continue with Google", { defaultValue: "Continue with Google" })}</span>
          </button>
          <button type="button" className="auth-social-btn" onClick={signInWithApple}>
            <img src={SignInImages.apple} alt="" />
            <span>{t("SignIn.Continue with Apple", { defaultValue: "Continue with Apple" })}</span>
          </button>
        </div>

        <button type="button" className="auth-guest" onClick={activateGuestMode}>
          {t("SignIn.Explore as guest")}
        </button>

        <div className="auth-safe-note">
          <span className="auth-safe-note-icon" aria-hidden="true">
            <ShieldOutlinedIcon />
          </span>
          <span className="auth-safe-note-text">
            {t("SignIn.Your information is safe", {
              defaultValue: "Your information is safe with us. We never share your data.",
            })}
          </span>
        </div>
        <p className="auth-help-link">
          {t("SignIn.Having Troubles")}?{" "}
          <a href="/faq.html" target="_blank" rel="noreferrer">
            {t("SignIn.Get Help")}
          </a>
        </p>
      </AuthSplitLayout>

        <SuccessToast
          show={showToast && !!String(toastMessage || "").trim()}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />

        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />

        <ErrorToast
          show={showErrorToast}
          message={ErrorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />

        {showModal && (
          <div
            className="modal fade show modal-md"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="setting-header d-flex justify-content-between align-items-center p-2">
                  <h6>Additional Details</h6>
                  {/* <span
                  className="material-symbols-sharp me-3 pointer"
                  onClick={handleModalClose}
                >
                  close
                </span> */}
                  <CloseSharpIcon
                    className="material-symbols-sharp me-3 pointer"
                    onClick={handleModalClose}
                  />
                </div>
                <Form>
                  <div className="row modal-p settings CreateCompany">
                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        Email
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={originalemail}
                        onChange={(e) => setOriginalEmail(e.target.value)}
                      // invalid={display && email === ""}
                      />
                      {/* {display && !email ? (
          <span className="error_msg_lbl">Enter Email </span>
        ) : null} */}
                    </div>
                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        FirstName
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      // invalid={display && firstName === ""}
                      />
                      {/* {display && !firstName ? (
          <span className="error_msg_lbl">Enter FirstName </span>
        ) : null} */}
                    </div>
                    <div className="col-md-12 mt-2">
                      <label htmlFor="about">
                        LastName
                        <span className="text-danger ms-2">*</span>
                      </label>
                      <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      // invalid={display && lastName === ""}
                      />
                      {/* {display && !lastName ? (
          <span className="error_msg_lbl">Enter LastName </span>
        ) : null} */}
                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="button"
                        className="closebtn me-2"
                        onClick={handleModalClose}
                        style={{ width: "60px" }}
                      >
                        {t("User Profile.Close")}
                      </button>
                      <button
                        type="button"
                        className="mainBtn1"
                        // onClick={_registerWithApple}
                        style={{ width: "70px" }}
                      >
                        {t("User Profile.Submit")}
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
        {flag && (
          <div
            className="modal fade show modal-md"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="d-flex justify-content-end p-2 pb-0">
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer mt-2"
                    onClick={handleOtpModalClose}
                  />
                </div>
                <div className="p-2 pt-2 text-center">
                  <h4>Hi {User_Name},</h4>
                  <h6>
                    <span className="fw-bold signUpModal">
                      Verify account by OTP
                    </span>{" "}
                  </h6>
                  {/* <p>Registration data saved, check mail for verification OTP</p> */}
                  <p>{Response_Message}</p>
                </div>
                <Form
                  className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
                  onSubmit={confimAcc === false ? 
                    ConfirmotpCheck :
                    otpCheck}
                  style={{ display: flag ? "block" : "none" }}
                >
                  <div className="mb-1 d-flex justify-content-center otp-input">
                    {/* <OTPInput
                    value={otp}
                    onChange={handleChangeOtp}
                    numInputs={6}
                  /> */}
                    <OtpInput
                      value={otp}
                      onChange={handleChangeOtp}
                      numInputs={4}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  <div className="text-center mt-3">
                    {/* <Button color="" className="theme-bg" type="submit">
                 </Button> */}
                    <div className="countdown-text d-flex justify-content-center">
                      {seconds > 0 || minutes > 0 ? (
                        <p className="me-3">
                          Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </p>
                      ) : (
                        <p className="me-3">Didn't recieve code?</p>
                      )}

                      <span
                        style={{
                          color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                          pointerEvents: seconds > 0 || minutes > 0 ? "none" : "auto",
                          cursor: seconds > 0 || minutes > 0 ? "not-allowed" : "pointer",
                        }}
                        onClick={confimAcc === false ? 
                          resendOTP :
                          Resend2FAOTP
                        }
                        className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                      >
                        Resend OTP
                      </span>
                    </div>
                    <button
                      type="submit"
                      className="mainBtn"
                      disabled={loadOTP || otp.length < 4}
                    >
                      {loadOTP ? "loading..." : "Verify OTP"}
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default SignIn;
